import { Identifiable } from "./identifiable";
import { Comment } from "./comment";
import { Id } from "./id";
import { DiscussionSubjectTypes } from "./discussionSubjectTypes";
import { task, Task } from "./task";
import { List } from "./list";
import { Event } from "./event";
import { Milestone } from "./milestone";
import { Project } from "./project";

type Discussion =
  | {
      entityType: DiscussionSubjectTypes.TASK;
      entityUuid: Id;
      subject: Identifiable<Task>;
      comments: Identifiable<Comment>[];
      commentsCount?: number;
      attributes: { [key: string]: string };
    }
  | {
      entityType: DiscussionSubjectTypes.LIST;
      entityUuid: Id;
      subject: Identifiable<List>;
      comments: Identifiable<Comment>[];
      commentsCount?: number;
      attributes: { [key: string]: string };
    }
  | {
      entityType: DiscussionSubjectTypes.EVENT;
      entityUuid: Id;
      subject: Identifiable<Event>;
      comments: Identifiable<Comment>[];
      commentsCount?: number;
      attributes: { [key: string]: string };
    }
  | {
      entityType: DiscussionSubjectTypes.MILESTONE;
      entityUuid: Id;
      subject: Identifiable<Milestone>;
      comments: Identifiable<Comment>[];
      commentsCount?: number;
      attributes: { [key: string]: string };
    }
  | {
      entityType: DiscussionSubjectTypes.PROJECT;
      entityUuid: Id;
      subject: Identifiable<Project>;
      comments: Identifiable<Comment>[];
      commentsCount?: number;
      attributes: { [key: string]: string };
    };

const discussion: Discussion = {
  entityType: DiscussionSubjectTypes.TASK,
  entityUuid: "",
  subject: { ...task, uuid: "" },
  comments: [],
  attributes: {},
};

export type { Discussion };

export { discussion };
